import { useEffect, useState } from 'react';

import {
  Announcement,
  getFormattedLongDate,
  LoaderSkeleton,
  parseLocalDate,
  ProgressBar,
} from '@utilities';

import { readClientSubscription } from '@api/client';

import styles from './_index.module.scss';

const SubscriptionOverviewV2 = () => {
  const [subscription, setSubscription] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSubscription = async () => {
      setError(null);

      try {
        const subscriptionData = await readClientSubscription();

        setSubscription(subscriptionData[0]);
      } catch (err) {
        setError(`Failed to load subscription info: ${err.message}`);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubscription();
  }, []);

  if (isLoading) {
    return (
      <LoaderSkeleton height={105}>
        <rect height="15" rx="2" ry="2" width="200" x="0" y="0" />
        <rect height="15" rx="2" ry="2" width="175" x="0" y="25" />
        <rect height="15" rx="2" ry="2" width="225" x="0" y="50" />
        <rect height="10" rx="2" ry="2" width="200" x="0" y="75" />
        <rect height="10" rx="2" ry="2" width="225" x="0" y="95" />
      </LoaderSkeleton>
    );
  }

  if (error) {
    return (
      <div>
        <Announcement text="There was an error fetching the subscription info." variant="error" />
      </div>
    );
  }

  if (!subscription) {
    return (
      <div>
        <Announcement
          header="No subscription information available."
          text="Please contact your Numerator team for more information."
          variant="info"
        />
      </div>
    );
  }

  if (!subscription?.hasStarted) {
    return (
      <div>
        <Announcement
          header={`Great news! Your subscription kicks off ${getFormattedLongDate(parseLocalDate(subscription.startDate))}`}
          text="Please contact your Numerator team for more information."
          variant="info"
        />
      </div>
    );
  }

  return (
    <>
      <div className={styles['subscription-overview-usage-row-container']}>
        <section className={styles['subscription-overview-usage-row']}>
          <span>Survey Completes</span>
          <span>
            <strong>
              {subscription?.currentPeriod?.usedCompletes} /{' '}
              {subscription?.currentPeriod?.totalCompletes} used
            </strong>
          </span>
        </section>
        <ProgressBar
          className={styles['subscription-overview-bar-neutral']}
          hasError={
            subscription?.currentPeriod?.totalCompletes > 0 &&
            subscription?.currentPeriod?.usedCompletes /
              subscription?.currentPeriod?.totalCompletes >=
              1
          }
          max={subscription?.currentPeriod?.totalCompletes}
          value={subscription?.currentPeriod?.usedCompletes}
        />
        <p className={styles['subscription-overview-period-end']}>
          Period ends{' '}
          {subscription?.currentPeriod?.endDate
            ? getFormattedLongDate(parseLocalDate(subscription.currentPeriod.endDate))
            : 'N/A'}
          . Unused completes (
          {subscription?.currentPeriod?.totalCompletes - subscription?.currentPeriod?.usedCompletes}
          ) expire at the end of the period.
        </p>
      </div>
    </>
  );
};

export default SubscriptionOverviewV2;
